import React from "react";
import { DashboardTimelineItem } from "../mockData";

type Props = {
  timeline: DashboardTimelineItem[];
};

const getIcon = (title: string) => {
  if (title.toLowerCase().includes("hearing"))
    return (
      <svg
        className="w-5 h-5 text-blue-600"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
    );
  if (title.toLowerCase().includes("deadline"))
    return (
      <svg
        className="w-5 h-5 text-amber-600"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <circle cx="12" cy="12" r="10" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6l4 2" />
      </svg>
    );
  return (
    <svg
      className="w-5 h-5 text-gray-600"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  );
};

const DashboardTimeline: React.FC<Props> = ({ timeline }) => {
  return (
    <section className="rounded-xl bg-white shadow-lg">
      <div className="border-b border-gray-100 px-6 py-4 flex justify-between items-center">
        <div>
          <h2 className="text-lg font-bold text-black flex items-center gap-2">
            <svg
              className="w-5 h-5 text-black"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <rect x="3" y="4" width="18" height="18" rx="2" />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16 2v4M8 2v4M3 10h18"
              />
            </svg>
            Upcoming Milestones
          </h2>
          <p className="mt-1 text-sm text-gray-600">
            Key dates and deadlines for complaint processing.
          </p>
        </div>
        <button className="text-sm text-gray-500 hover:text-black transition">
          View All →
        </button>
      </div>

      <div className="space-y-4 p-4">
        {timeline.map((item) => (
          <article
            key={item.title}
            className="flex items-start gap-4 rounded-xl border border-gray-100 bg-white p-4 shadow-sm hover:shadow-md transition-all duration-200"
          >
            <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-gray-100">
              {getIcon(item.title)}
            </div>

            <div className="flex-1">
              <h3 className="text-sm font-bold text-black">{item.title}</h3>
              <p className="mt-1 text-xs uppercase tracking-wide text-gray-600">
                {item.date}
              </p>
              <p className="mt-2 text-sm leading-6 text-gray-700">
                {item.description}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default DashboardTimeline;
